import {Pipe, PipeTransform} from '@angular/core';
import {isOrder, isSubmittal} from '../../model';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'rates'})
export class RatesPipe implements PipeTransform {

  constructor(private Translate: TranslateService) {
  }

  transform(input: Order | Submittal): string {
    if (isOrder(input)) {
      if (input.placementTypeId === 3) {
        return this.formatHourlyRate(input);
      } else if (input.placementTypeId === 2) {
        return this.formatSalaryRate(input);
      } else if (input.placementTypeId === 1) {
        return `${this.formatHourlyRate(input)} ${this.formatSalaryRate(input)}`;
      }
    } else if (isSubmittal(input)) {
      return `${input.currencySymbol}${input.rate.toFixed(2)}${input.country !== 'GB' ? '/hour' : ''}`;
    }
    return '';
  }

  private formatHourlyRate(order: Order): string {
    let label = 'order.position-details.hourly';
    // FIXME use enums
    if (order.placementTypeId === 3 && order.rateTypeId === 2) {
      label = 'order.position-details.daily';
    }
    if (order.rateMin !== 0 && order.rateMax !== 0) {
      if (order.rateMin === order.rateMax) {
        return order.currencySymbol + order.rateMin.toFixed(2) + this.Translate.instant(label);
      } else {
        return order.currencySymbol + order.rateMin.toFixed(2) + ' - ' + order.currencySymbol + order.rateMax.toFixed(2) + ' '
          + this.Translate.instant(label);
      }
    } else if (order.rateMin !== 0 && order.rateMax === 0) {
      return order.currencySymbol + order.rateMin.toFixed(2) + ' ' + this.Translate.instant(label)
        + this.Translate.instant('order.position-details.and-up');
    } else if (order.rateMax !== 0) {
      return order.currencySymbol + order.rateMax.toFixed(2) + this.Translate.instant('order.position-details.up-to')
        + this.Translate.instant(label);
    }
    return '';
  }

  private formatSalaryRate(order: Order): string {
    const label = 'order.position-details.yearly';
    if (order.salaryMin !== 0 && order.salaryMax !== 0) {
      if (order.salaryMin === order.salaryMax) {
        return order.currencySymbol + order.salaryMin.toFixed(2) + this.Translate.instant(label);
      } else {
        return `${order.currencySymbol + order.salaryMin.toFixed(2)} - ${order.salaryMax.toFixed(2)} ${this.Translate.instant(label)}`;
      }
    } else if (order.salaryMin !== 0 && order.salaryMax === 0) {
      return order.currencySymbol + order.salaryMin.toFixed(2) + ' ' + this.Translate.instant(label)
        + this.Translate.instant('order.position-details.and-up');
    } else if (order.salaryMax !== 0) {
      return order.currencySymbol + order.salaryMax.toFixed(2) + this.Translate.instant('order.position-details.up-to')
        + this.Translate.instant(label);
    }
  }
}
